import axiosClient from '@/utils/axiosClient';
var path = 'campaign';
var displayPath = 'display';
export var getAllCampaign = function (payload) {
    var queryString = payload.queryString;
    return axiosClient.post("/".concat(path, "/getAllCampaigns"), {}, { params: queryString });
};
export var getDisplaysForCampaign = function (payload) {
    var queryString = payload.queryString;
    return axiosClient.post("/".concat(displayPath, "/listDisplaysForCampaign/"), {}, { params: queryString });
};
export var createCampaign = function (payload) {
    return axiosClient.post("/".concat(path, "/createCampaign"), payload.body);
};
export var assignDisplay = function (payload) {
    return axiosClient.post("/".concat(path, "/assignDisplays"), payload.body);
};
export var updateCampaign = function (payload) {
    return axiosClient.post("/".concat(path, "/updateCampaign/").concat(payload.pathParams), payload.body);
};
export var deleteCampaign = function (body) {
    return axiosClient.post("/".concat(path, "/deleteCampaigns"), body);
};
export var getDetailCampaign = function (payload) {
    return axiosClient.post("/".concat(path, "/getCampaignDetails/").concat(payload.pathParams), {});
};
